import { call, put, takeLatest } from 'redux-saga/effects';
import {
    GET_PROJECTS,
    GET_PROJECTS_SUCCESS,
    GET_PROJECTS_FAIL,
    GET_PROJECT,
    GET_PROJECT_SUCCESS,
    GET_PROJECT_FAIL,
} from '../../constants/actions/project.constants';
import { SurveyService } from '../../services';
import { IAction } from '../../types';
import { NotificationActions } from '../../common/actions/NotificationActions';

export function* getProjects() {
    try {
        const { data } = yield call(SurveyService.getProjects);
        if (!data) {
            throw new Error('Projects not found');
        }
        yield put({ type: GET_PROJECTS_SUCCESS, payload: data });
    } catch (err) {
        const message = (err as Error).message;
        yield put(NotificationActions.error(message));

        yield put({ type: GET_PROJECTS_FAIL, error: message });
    }
}

export interface IProjectAction extends IAction {
    type: typeof GET_PROJECT;
    payload: number;
}

export function* getProject(action: IProjectAction) {
    try {
        const { data } = yield call(SurveyService.getProject, action.payload);
        if (!data) {
            throw new Error('Projects not found');
        }
        yield put({ type: GET_PROJECT_SUCCESS, payload: data });
    } catch (err) {
        const message = (err as Error).message;
        yield put(NotificationActions.error(message));

        yield put({ type: GET_PROJECT_FAIL, error: message });
    }
}

export const projectSaga = [
    takeLatest(GET_PROJECTS, getProjects),
    takeLatest(GET_PROJECT, getProject),
];
